module.exports = __webpack_public_path__ + "img/b5f4353.jpg";